import { injectedStore } from '../../ConfigureStore';

export default function getAPIVersion(): string {
  return injectedStore.getState().config.apiVersion;
}
